<template>
  <el-dialog
    title="中央空调系统运行策略"
    :visible.sync="$parent.dialogVisible"
    width="30%"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="策略名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="注意事项" prop="desc">
        <el-input type="textarea" rows="5" v-model="ruleForm.desc"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$parent.dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ruleForm: {
        name: "",
        desc: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入策略名称", trigger: "blur" },
          { whitespace: true, message: "请输入策略名称", trigger: "blur" },
        ],
        desc: [
          { required: true, message: "请填写注意事项", trigger: "blur" },
          { whitespace: true, message: "请填写注意事项", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveStrategy", {
            name: this.ruleForm.name,
            remark: this.ruleForm.desc,
            id: this.dialogInfo.id ? this.dialogInfo.id.id : "",
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    this.ruleForm.name = this.dialogInfo.id ? this.dialogInfo.name : "";
    this.ruleForm.desc = this.dialogInfo.id ? this.dialogInfo.remark : "";
  },
};
</script>

<style></style>
